import React, { useEffect } from 'react';
import classnames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import { getDaysLeft } from 'swag-common/utils/date-lib';
import { useTimeLeftForLimitedEdition } from 'swag-client-common/hooks/use-time-left-for-limited-edition';
import { Countdown } from '../countdown';
import animationClasses from '../limited-edition-in-stock/appear.anim.scss';
import classes from './limited-edition-countdown.scss';
export let LimitedEditionCountdownStyle = /*#__PURE__*/function (LimitedEditionCountdownStyle) {
  LimitedEditionCountdownStyle["Big"] = "big";
  LimitedEditionCountdownStyle["FullWidth"] = "fullWidth";
  return LimitedEditionCountdownStyle;
}({});
const switchStyles = style => {
  switch (style) {
    case LimitedEditionCountdownStyle.Big:
      return classes.wrapperBig;
    case LimitedEditionCountdownStyle.FullWidth:
      return classes.wrapperFullWidth;
    default:
      return '';
  }
};
export const LimitedEditionCountdownComponent = ({
  expirationDate,
  isOutOfStock,
  style,
  className,
  onTimerEnd
}) => {
  const leftTime = useTimeLeftForLimitedEdition(expirationDate);
  const days = getDaysLeft(leftTime);
  const isTimeOver = leftTime === 0;
  const isProductUnavailable = isOutOfStock || isTimeOver;
  useEffect(() => {
    if (isTimeOver && onTimerEnd) {
      onTimerEnd();
    }
  }, [isTimeOver]);
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.wrapper, switchStyles(style), className, {
      [classes.productUnavailable]: isProductUnavailable
    })
  }, isProductUnavailable ? /*#__PURE__*/React.createElement(CSSTransition, {
    in: isProductUnavailable,
    timeout: 300,
    classNames: animationClasses,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.LENotAvailable
  }, "No longer available")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Countdown, {
    leftTime: leftTime
  }), `${days ? '' : 'Time'} Remaining`));
};